// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__138mm","disabled":"FileBtn_disabled__jeZrC","warn":"FileBtn_warn__xfPAp","fade":"FileBtn_fade__2U59C"};